export default __webpack_public_path__ + "static/media/gallery_10.e833d4ea.jpg";